import React, { useState, useEffect, useRef } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Philosophy from "./components/Philosophy";
import Panels from "./components/Panels";
import About from "./components/About";
import Listing from "./components/Listing";
import Testimonials from "./components/Testimonials";
import FeatureSection from "./components/FeatureSection";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import InquiryModal from "./components/InquiryModal";
import AdminLogin from "./admin/AdminLogin";
import AdminDashboard from "./admin/AdminDashboard";
import ProtectedRoute from "./admin/ProtectedRoute";
import { buySection, sellSection } from "./mock";

function HomePage() {
  const [modalOpen, setModalOpen] = useState(false);
  const autoShown = useRef(false);
  const navigate = useNavigate();

  const closeModal = () => setModalOpen(false);
  const goContact = () => navigate("/contact");

  // Private Inquiry popup opens on its own 6 seconds after load (once)
  useEffect(() => {
    const t = setTimeout(() => {
      if (!autoShown.current) {
        autoShown.current = true;
        setModalOpen(true);
      }
    }, 6000);
    return () => clearTimeout(t);
  }, []);

  return (
    <>
      <Navbar />
      <Hero />
      <Philosophy />
      <Panels onContact={goContact} />
      <About onContact={goContact} />
      <Listing />
      <Testimonials />
      <FeatureSection id="buy" data={buySection} reverse={false} onContact={goContact} />
      <FeatureSection id="sell" data={sellSection} reverse={true} onContact={goContact} />
      <Footer />
      <InquiryModal open={modalOpen} onClose={closeModal} />
    </>
  );
}

function ContactPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Navbar />
      <Contact />
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
